/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useEffect, useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import { SupportWidgetButton } from '@fitinsur/components';
import {
  Container,
  Logo,
  Title,
  List,
  Item,
  Settings,
  SubTitle,
  Content,
  Version,
  SubTitleVersion,
  TextVersion,
} from "./styles";
import Icon from "../Icon/";
import { FitinsurAPI } from "../../utils";
import { GlobalAuthContext } from "../../store/context";
import { useHistory, useLocation } from "react-router-dom";
import logo from "../../assets/logos/sompo_logo.png";
import HasPermission from 'components/HasPermission/index';
import Access from 'constants/Access';

export default function Menu(props) {
  const setShowProfile = props.showProfile;

  const [showDashboard, setShowDashboard] = useState(false);
  const [showEnquires, setShowEnquires] = useState(false);
  const [showPolicies, setShowPolicies] = useState(false);
  const [showClaims, setShowClaims] = useState(false);
  const [showPayments, setShowPayments] = useState(false);
  const [showRenewals, setShowRenewals] = useState(false);
  const [showManagement, setShowManagement] = useState(false);
  const [creditAnalysis, setCreditAnalysis] = useState(false);
  const fitinsur = new FitinsurAPI();
  const authContext = useContext(GlobalAuthContext);
  const packageJsonInfo = require('../../../package.json');

  const history = useHistory();
  const { pathname } = useLocation();

  function requestAccess(username, dsDomPrivilege, idDomain, idPersonRelation, idOperation, menu) {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestAccess(username, dsDomPrivilege, idDomain, idPersonRelation, idOperation)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.ret_code == "200") {
          menu(true)
        }
      }).catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    requestAccess("", "READ", "317", null, null, setShowDashboard)
    requestAccess("", "READ", "318", null, null, setShowEnquires)
    requestAccess("", "READ", "319", null, null, setShowPolicies)
    requestAccess("", "READ", "320", null, null, setShowClaims)
    requestAccess("", "READ", "321", null, null, setShowPayments)
    requestAccess("", "READ", "322", null, null, setShowRenewals)
    requestAccess("", "READ", "462", null, null, setShowManagement)
    // requestAccess("", "READ", "716", null, null, setCreditAnalysis)
  }, []);

  return (
    <Content>
      <Container>
        <Logo src={logo} alt="Logo da Sompo"/>
        <Title>Menu</Title>
        <List>
          {showDashboard ? <NavLink to="/home" activeClassName='active' exact={true}><Item><Icon name="dashboard" />Dashboard</Item></NavLink> : ''}
          {showEnquires ? <NavLink to="/enquiries?hideInactiveTransactions=true&hideExecutedTransactions=true" activeClassName='active' className={pathname.includes('/list') && 'active'} exact={true} onClick={() => { localStorage.removeItem('enquiries_filter') }}><Item><Icon name="enquiries" />Cotações</Item></NavLink> : ''}
          {showPolicies ? <NavLink to="/polices" activeClassName='active' exact={true} onClick={() => { localStorage.removeItem('policies_filter') }}><Item><Icon name="policies" />Apólices e Endossos</Item></NavLink> : ''}
          {/* {showClaims ? <NavLink to="/claims" activeClassName='active' exact={true} onClick={() => { localStorage.removeItem('claims_filter') }}><Item><Icon name="claims" />Claims</Item></NavLink> : ''} */}
          {/* {showPayments ? <NavLink to="/payments?hideAbortedTransactions=true&hideDirectPayment=true" activeClassName='active' exact={true} onClick={() => { localStorage.removeItem('payment_filter') }}><Item><Icon name="payments" />Payments</Item></NavLink> : ''} */}
          {showRenewals ? <NavLink to="/renewals" activeClassName='active' exact={true} onClick={() => { localStorage.removeItem('renewals_filter') }}><Item><Icon name="renewals" />Renovação</Item></NavLink> : ''}
          {showManagement ? <NavLink to="/management/58/person" activeClassName='active' exact={true} onClick={() => { localStorage.removeItem('management_filter') }}><Item><Icon name="management" />Administração</Item></NavLink> : ''}
          {creditAnalysis ? <NavLink to="/credit-analysis" activeClassName='active' exact={true} onClick={() => { localStorage.removeItem('credit_analysis_filter') }}><Item><Icon name="credit-analysis" />Análise de Crédito</Item></NavLink> : ''}
        </List>
        <div style={{
            position: 'absolute',
            maxHeight: '320px',
            paddingTop: '10px',
            bottom: 0,
          }}
        >
        <Settings>
          <List>
            <SubTitle>Configurações</SubTitle>
            <Item
              onClick={() => {
                setShowProfile(true);
              }}
            >
              <Icon name="user" />
              Minha Conta
            </Item>
            
            <SupportWidgetButton />

            <NavLink to="/login">
              <Item>
                <Icon name="logout" />
                Sair
              </Item>
            </NavLink>

            </List>
          </Settings>
          <Version>
            <SubTitleVersion>Version</SubTitleVersion>
            <TextVersion>{packageJsonInfo.version}</TextVersion>
          </Version>
        </div>
      </Container>
    </Content>
  );
}